import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import cx from 'classnames'

import { checkEmail } from '../../../api'

import Model, { onChange as onChangeModel } from '../../../lib/Model'
import { Form, Field, Icon, Input, Button, Note, H2, Copyright } from '../../Common'

import style from './Step.scss'

class Step1 extends Component {
  static propTypes = {
    mobile: PropTypes.bool,
    onNextStep: PropTypes.func.isRequired,
    isFromFacebook: PropTypes.bool,
    form: PropTypes.shape({
      email: PropTypes.string,
      password: PropTypes.string,
    }),
  }

  state = {
    form: {
      submitted: false,
      email: new Model('email', this.props.form.email, 'email'),
      password: new Model('password', this.props.form.password, 'password'),
    },
  }

  UNSAFE_componentWillMount() {
    const { email, password } = this.props.form
    if (email || password) {
      const nextState = { ...this.state }
      if (email) {
        nextState.form.email.value = email
      }
      if (password) {
        nextState.form.password.value = password
      }
      this.setState(nextState)
    }
  }

  componentDidMount() {
    this.emailInput.validators.async.uniqueEmail = checkEmail
  }

  handleChange = (event, model) => {
    this.setState(onChangeModel(model))
  }

  handleSubmit = () => {
    const { submitted, email, password } = this.state.form
    if (email.pending) {
      return
    }
    if (submitted === false) {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
        },
      }))
    }
    if (email.invalid || (password.pristine || password.invalid)) {
      return
    }

    this.props.onNextStep(
      {
        email: email.value,
        password: password.value,
      },
      2,
    )
  }

  render() {
    const mobile = this.props.mobile
    const { submitted, email, password } = this.state.form
    const emailInvalid = submitted && email.untouched && email.error.required
    const emailUniqueInvalid = email.untouched && !email.pending && email.error.uniqueEmail
    const passwordInvalid = submitted && ((password.untouched && password.error.required) || password.pristine)
    const passwordMinLengthInvalid = submitted && password.untouched && password.error.minLength

    return (
      <div className={style.step}>
        <H2 className={style.title}>cadastro de nova conta</H2>

        <Form id="form-step1" onSubmit={this.handleSubmit} className={style.form}>
          <Field
            label="e-mail corporativo"
            className={cx(style.field, {
              [style.invalid]: emailInvalid || emailUniqueInvalid,
            })}
          >
            <Input
              model={email}
              id="email"
              onChange={this.handleChange}
              autoFocus
              required
              invalid={emailInvalid || emailUniqueInvalid}
              size="xl"
              ref={(input) => {
                this.emailInput = input
              }}
            />
            <Note id="erro-email-em-uso" error show={emailUniqueInvalid}>
              este e-mail já está em uso
            </Note>
            <Note id="erro-email-obrigatorio" error show={emailInvalid}>
              campo obrigatório
            </Note>
          </Field>

          <Field label="senha" className={style.field}>
            <Input
              id="senha"
              model={password}
              onChange={this.handleChange}
              minLength={5}
              required
              invalid={passwordInvalid || passwordMinLengthInvalid}
              size="xl"
            />
            <Note id="erro-senha-obrigatoria" error show={passwordInvalid}>
              campo obrigatório
            </Note>
            <Note id="erro-senha-erro" error show={passwordMinLengthInvalid}>
              a senha deve conter o mínimmo de 5 caracteres
            </Note>
          </Field>

          <Button id="button-proximo" submit loading={email.pending} xl>
            próximo
          </Button>

          <Note id="erro-revise" error show={submitted && (email.invalid || password.invalid)}>
            revise os campos do formulário e tente novamente
          </Note>

          <Note>passo 1 de 2</Note>
        </Form>

        {!mobile && (
          <Link id="link-login" to="/login" className={style.back}>
            login <Icon value="keyboard_arrow_right" material />
          </Link>
        )}
        <Copyright className={style.copyright} />
      </div>
    )
  }
}

export default Step1



// WEBPACK FOOTER //
// ./src/components/Signup/Steps/Step1.js